import script from "./UiPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./UiPopup.vue?vue&type=script&setup=true&lang=js"

import "./UiPopup.vue?vue&type=style&index=0&id=6756ae19&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6756ae19"]])

export default __exports__